import styled from '@emotion/styled'

export const SeparatorGridItem = styled.div`
  grid-column: span 4;
`
